module.exports = __webpack_public_path__ + "img/icon_5_55.1059441b.png";